import { Component } from '@angular/core';
import { getSegmentName, translateSegments } from '@shared-libs/helpers';
import { Segment } from '@beego/ngx-segment';

@Component({
	selector: 'statistics-desktop-page',
	templateUrl: 'statistics.desktop.page.html',
	styleUrls: ['./statistics.desktop.page.scss'],
})
export class StatisticsDesktopPage {
	public readonly segments: Array<Segment> = translateSegments([
		'IMPACT',
		'CLIENTS',
		'ACTIVITIES',
		'ATTENDANCES',
		'ANONYMOUS_ATTENDANCES',
		'RATINGS',
		'CANCELLATIONS',
		'DEVICES',
		// 'BEEGO',
		'DIGICHEQUES',
	]);
	public selectedSegment: string = getSegmentName(this.segments[0]);
	public getSegmentName = getSegmentName;

	public onSelectedSegmentChange(segment: string): void {
		this.selectedSegment = segment;
	}
}
